import type { NextPage } from 'next'
import { SampleBook } from '@/client/modules/SampleBook'
import { SampleBookProps } from '@/client/modules/SampleBook/types'
import { getCMSContent } from '@/client/utils'

const SampleBookPage: NextPage<SampleBookProps> = (data) => <SampleBook {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'SAMPLE_BOOK')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default SampleBookPage
